<template>
    <div>
        <h1>122</h1>
        <videoPlayer  :options="playerOptions" :playsinline="true"></videoPlayer>
    </div>
</template>
<script>
import {videoPlayer } from 'vue-video-player';  
export default {
    name:'MyVideoPlayer',
    components:{videoPlayer },
    props:{
        videoSrc:{
            type:[String]
        },
        posterUrl:{
            type:[String]
        }
    },
    watch: { 
        videoSrc(newValue,oldValue){
            this.playerOptions.sources.src=newValue
        },
        posterUrl(newValue,oldValue){
            this.playerOptions.poster=newValue
        }
    },
    data() {  
        return {  
            playerOptions: {  
                playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度选项  
                sources: [{ // 视频源  
                    type: 'video/mp4', // 视频格式  
                    src: '//vjs.zencdn.net/v/oceans.mp4' // 视频文件路径或URL  
                }],  
                poster: 'path/to/your/poster.jpg', // 视频封面图片路径或URL  
                // 其他选项...  
            }

        };  
    }  
}

</script>